






























































































import { Component, Vue } from "vue-property-decorator";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import companyApi from "@/api/companyApi";
import Company from "@/model/company";
import click2Top from "@/common/directives/click2Top";
import store from "@/store";
import {namespace} from "vuex-class";
import qNotify from "@/common/qNotify";
const authStore = namespace("Auth");
@Component({
  name: "PartnerList",
  directives: {
    click2Top,
  },
  components: {
    QPaginate,
    QTableHeader,
  },
})
export default class PartnerList extends Vue {
  @authStore.Getter
  public getCurrentyCompany!: Company;
  @authStore.Getter
  public isAdmin;

  public adminHeaders = [
    { id: "id", name: "ID" },
    { id: "name", name: "会社名", order: "desc" },
    { id: "address1", name: "所在地", order: "desc" },
    { id: "licenses", name: "ライセンス数" },
    { id: "representative_user.username", name: "システム代表者名", order: "desc" },
    { id: "cooperate_count", name: "連携数" },
    { id: "", name: "" },
  ];
  public headers = [
    { id: "id", name: "ID" },
    { id: "name", name: "会社名", order: "desc" },
    { id: "address1", name: "所在地", order: "desc" },
    { id: "representative_user.username", name: "システム代表者名", order: "desc" },
    { id: "role_id", name: "権限", order: "desc" },
    { id: "", name: "" },
  ];

  public search = this.searchInital();

  public searchInital() {
    return {
      keyword: null,
      sort: "created_at",
      direction: "desc",
      page: "1",
    };
  }

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public partners: Company[] = null;

  get getPaginate() {
    return this.pagination;
  }

  get usingCompanyId() {
    return this.getCurrentyCompany ? this.getCurrentyCompany.id : "";
  }

  public async partnerList() {
    const result = await companyApi.index(this.search);
    this.pagination = result.paginate;
    this.partners = result.list;
  }

  mounted() {
    this.initalSearch(null);
    this.partnerList();
  }

  public createCooperate() {
    store.dispatch("Company/setMcCompanyId", this.usingCompanyId);
    this.$emit('createCooperate');
  }

  public onShowPartnerInfor(partner) {
    store.dispatch("Company/setCompany", partner);
    this.$emit('partnerInfo');
  }
  public editPartner(partner, cooperateIndex) {
    store.dispatch("Company/setCompaniesCooperate", {
      'id': partner.belongs_to_company.cooperate_id,
      'cooperate_company_id': partner.id,
      'cooperate_company_name': partner.name,
      'role_id': partner.role_id,
    });
    this.$emit('editCooperate', cooperateIndex);
  }

  public deleteCooperate(name, cooperateId, index) {
    this.$modal.showDelete({
      text: this.$t("deleteCooperate", { company_name: name }),
      confirmText: this.$t("confirm_text.yes"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await companyApi.deleteCooperate(cooperateId);
        if (result.meta.status === 200) {
          qNotify.success({
            text: this.$t("companies.cooperate_deleted"),
          });
          this.partners.splice(index, 1);
        } else {
          qNotify.error({
            text: this.$t("companies.cooperate_deleted_fail"),
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public onShowCreatePage() {
    store.dispatch("Company/clear");
    store.dispatch("Company/setMcCompanyId", this.usingCompanyId);
    this.$emit('partnerCreate');
  }

  public clear() {
    this.search = this.searchInital();
    this.changeState();
    this.partnerList();
  }

  public doSearch(query: any): void {
    this.search = { ...this.search, ...query };
    this.partnerList();
  }

  public onSearch(): void {
    this.changeState();
    this.partnerList();
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    this.search.page = "1";
    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    this.search = {
      ...this.search,
      ...query,
    };
  }
}
